import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
export function usePixToast(options) {
    const { handleDeletePixKey } = options;
    const { t } = useTranslation();
    const [copyToast, setCopyToast] = useState({ isVisible: false, message: '' });
    const [deleteToast, setDeleteToast] = useState({ isVisible: false, message: '' });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPixKey, setSelectedPixKey] = useState(null);
    const handleCopy = useCallback(() => {
        setCopyToast({
            isVisible: true,
            message: t('pix-keys.copy-success'),
        });
    }, [t]);
    const handleDelete = useCallback((pixKey) => {
        setSelectedPixKey(pixKey);
        setShowDeleteModal(true);
    }, []);
    const handleCloseDeleteModal = useCallback(() => {
        setShowDeleteModal(false);
        setSelectedPixKey(null);
    }, []);
    const handleConfirmDelete = useCallback(async () => {
        if (selectedPixKey) {
            const success = await handleDeletePixKey(selectedPixKey.key);
            return success;
        }
        return false;
    }, [selectedPixKey, handleDeletePixKey]);
    const handleCloseCopyToast = useCallback(() => {
        setCopyToast({ isVisible: false, message: '' });
    }, []);
    const handleCloseDeleteToast = useCallback(() => {
        setDeleteToast({ isVisible: false, message: '' });
    }, []);
    const showDeleteSuccessToast = useCallback(() => {
        setDeleteToast({
            isVisible: true,
            message: t('pix-keys.delete-success'),
        });
    }, [t]);
    return {
        copyToast,
        deleteToast,
        showDeleteModal,
        selectedPixKey,
        handleCopy,
        handleDelete,
        handleCloseDeleteModal,
        handleConfirmDelete,
        handleCloseCopyToast,
        handleCloseDeleteToast,
        showDeleteSuccessToast,
    };
}
